var _defs, _g, _g2, _path, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIpn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Main_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st11 {\n        fill: #f57c3f;\n      }\n\n      .st12 {\n        fill: url(#linear-gradient);\n      }\n\n      .st13 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 187.99,
    y1: 122.95,
    x2: 371.21,
    y2: 122.95,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#902472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7a246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#642462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#53245d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#472459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#402456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 505.35,
    y1: 122.96,
    x2: 182.61,
    y2: 122.96,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#492962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a3276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61367e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 440.21,
    y1: 122.89,
    x2: 96.49,
    y2: 122.89,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#492962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a3276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61367e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 268.61,
    y1: 134.93,
    x2: -24.52,
    y2: 134.93,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f2456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#492962"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a3276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61367e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 118.27,
    y1: 174.04,
    x2: 248.41,
    y2: 174.04,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b2b74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#52286a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#47265e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#402457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 288.48,
    y1: 85.16,
    x2: -18.88,
    y2: 85.16,
    gradientTransform: "translate(0 247.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#902472"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#7a246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#642462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#53245d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#472459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#402456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2456"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 196.99,
    y1: 122.95,
    x2: 362.21,
    y2: 122.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 475.68,
    y1: 122.96,
    x2: 204.81,
    y2: 122.96,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 410.55,
    y1: 122.89,
    x2: 118.69,
    y2: 122.89,
    xlinkHref: "#linear-gradient2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 258.82,
    y1: 134.93,
    x2: 3.32,
    y2: 134.93,
    xlinkHref: "#linear-gradient3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 127.27,
    y1: 174.04,
    x2: 239.41,
    y2: 174.04,
    xlinkHref: "#linear-gradient4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 258.82,
    y1: 85.16,
    x2: 3.32,
    y2: 85.16,
    xlinkHref: "#linear-gradient5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M68.35,98.79c-2.89,0-5.6-1.38-7.29-3.72-1.69-2.34-2.16-5.35-1.26-8.09l12.67-38.56c3.05-9.29,11.67-15.53,21.45-15.53h28.37c2.89,0,5.6,1.38,7.29,3.72,1.69,2.34,2.16,5.35,1.26,8.09l-15.67,47.68c-1.12,3.7-4.55,6.41-8.62,6.41h-38.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.29,41.89l-15.74,47.89h0s-38.2.01-38.2.01l12.67-38.56c1.83-5.57,7.03-9.34,12.9-9.34h28.37M122.29,23.89h-28.37c-13.68,0-25.73,8.73-30,21.72l-12.67,38.56c-1.8,5.48-.86,11.5,2.52,16.17,3.39,4.68,8.81,7.44,14.58,7.44h38.2c8.16,0,15.06-5.44,17.26-12.89l15.58-47.39c1.8-5.48.87-11.5-2.52-16.18-3.39-4.68-8.81-7.44-14.58-7.44h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M32.26,213.89c-2.89,0-5.6-1.39-7.3-3.73-1.69-2.34-2.16-5.35-1.25-8.1l20.58-62.17c5.75-17.38,21.77-29.52,38.95-29.52h36.93c.24,0,.49-.01.73-.01,2.39,0,4.69.95,6.37,2.65,2.57,2.58,3.34,6.45,1.94,9.81-1.4,3.36-4.67,5.55-8.31,5.55h-.42c-2.41.13-3.55,1.53-6.27,9.87-.19.58-.38,1.15-.56,1.72-2.63,7.89-9.96,30.12-9.96,30.12l-12.45,37.64c-1.22,3.68-4.66,6.17-8.54,6.17h-50.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M120.91,119.36h0s-.6,0-.6,0c.19,0,.39,0,.59,0M120.32,119.36c-10.23.35-12.59,9.94-15.19,17.75-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.07M120.91,101.36c-.28,0-.56,0-.84,0h-36.82c-21.02,0-40.55,14.68-47.5,35.7l-20.58,62.16c-1.82,5.49-.89,11.51,2.5,16.2,3.38,4.68,8.81,7.46,14.59,7.46h50.45c7.76,0,14.65-4.98,17.09-12.35l12.45-37.63c.08-.23,7.37-22.32,9.96-30.11.19-.58.39-1.18.58-1.78.38-1.18.88-2.71,1.35-3.95,5.95-1.08,11.05-5.12,13.42-10.84,2.78-6.74,1.22-14.49-3.95-19.63-3.37-3.35-7.95-5.25-12.7-5.25h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M274.08,214.1c-4.3,0-8.01-3.05-8.83-7.29l-9.73-50.19-13.07,49.92c-1.04,3.96-4.61,6.72-8.71,6.72h-36.74c-2.86,0-5.56-1.36-7.25-3.67-1.7-2.31-2.19-5.29-1.34-8.02l47.79-152.54c.16-.59.38-1.17.67-1.73,1.31-2.57,3.76-4.37,6.61-4.82l48.98-7.73c.47-.07.94-.11,1.4-.11,1.99,0,3.94.66,5.54,1.9,1.96,1.53,3.21,3.81,3.43,6.29l2.99,33.44,3.86-14.74c4.16-15.9,18.55-27,34.99-27h6.15c6.37,0,12.26,2.89,16.15,7.93,3.89,5.04,5.2,11.47,3.59,17.63l-38.35,146.42c-1.02,3.9-4.52,6.65-8.55,6.72,0,0-49.5.85-49.56.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M350.8,43.54c7.47,0,12.92,7.06,11.03,14.29l-38.35,146.42-49.4.85-17.26-89-23.09,88.16h-36.74l47.89-152.87v-.02s48.97-7.73,48.97-7.73l7.58,84.84,16.94-64.66c3.13-11.95,13.93-20.28,26.28-20.28h6.15M350.8,25.54h-6.15c-12.91,0-24.82,5.49-33.16,14.51-.85-4.18-3.17-7.95-6.56-10.6-3.18-2.48-7.09-3.81-11.07-3.81-.93,0-1.87.07-2.81.22l-48.98,7.73c-5.67.89-10.57,4.43-13.19,9.53-.6,1.16-1.06,2.36-1.39,3.59l-47.67,152.17c-1.71,5.47-.72,11.42,2.67,16.04,3.39,4.62,8.78,7.34,14.51,7.34h36.74c8.18,0,15.34-5.52,17.41-13.44l3.06-11.68,2.21,11.38c1.64,8.47,9.06,14.57,17.67,14.57.1,0,.21,0,.31,0l49.4-.85c8.07-.14,15.06-5.63,17.1-13.44l38.35-146.42c2.32-8.89.44-18.15-5.17-25.42-5.61-7.26-14.09-11.43-23.27-11.43h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M273.75,214.1c-2.82,0-5.48-1.32-7.18-3.57-1.7-2.25-2.25-5.17-1.48-7.88l45.87-161.56c1.1-3.87,4.64-6.54,8.66-6.54.02,0,23.05.15,23.05.15h25.07c2.8,0,5.44,1.3,7.15,3.53,1.7,2.23,2.27,5.12,1.54,7.82l-43.67,161.41c-1.06,3.92-4.62,6.65-8.69,6.65h-50.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M319.62,43.54l22.99.15h25.13l-43.67,161.41h-50.32l45.87-161.56M319.62,25.54c-8.04,0-15.12,5.34-17.31,13.08l-45.87,161.56c-1.54,5.43-.45,11.27,2.95,15.77,3.4,4.5,8.72,7.15,14.36,7.15h50.32c8.13,0,15.25-5.45,17.38-13.3l43.67-161.41c1.46-5.41.32-11.19-3.08-15.64-3.41-4.45-8.69-7.06-14.29-7.06h-25.07l-22.93-.15s-.08,0-.12,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.97,214.08c-2.81,0-5.47-1.32-7.17-3.56-1.7-2.24-2.26-5.15-1.5-7.86l38.53-138.11c.04-.14.08-.27.12-.41,5.74-17.35,21.73-29.46,38.89-29.46h32.41c4.96,0,8.99,4.03,8.99,9s-4.02,9-9,9h0c-2.54,0-3.69.8-6.63,9.82-.19.59-.38,1.17-.57,1.75-2.46,7.38-9.05,27.36-9.85,29.78l-30.35,113.38c-1.05,3.94-4.62,6.67-8.69,6.67h-45.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M294.25,43.68h0c-10.7,0-13.09,9.78-15.74,17.71-2.63,7.88-9.94,30.06-9.94,30.06l-30.42,113.63h-45.17l38.53-138.11c4.05-12.25,15.88-23.29,30.34-23.29h32.41M294.25,25.68h-32.41c-20.99,0-40.49,14.66-47.43,35.64-.09.27-.17.54-.25.81l-38.53,138.11c-1.51,5.42-.4,11.24,3,15.72,3.4,4.48,8.71,7.12,14.34,7.12h45.17c8.15,0,15.28-5.47,17.39-13.35l30.29-113.14c1.09-3.29,7.38-22.4,9.76-29.51.2-.59.39-1.19.59-1.8.38-1.16.87-2.68,1.34-3.91,8.38-1.54,14.74-8.88,14.74-17.7,0-9.94-8.05-18-17.99-18h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.24,176.26c-2.89,0-5.6-1.39-7.29-3.73-1.69-2.34-2.16-5.35-1.25-8.09,0,0,7.34-22.24,9.98-30.16.18-.55.36-1.09.54-1.64,2.54-7.79,7.28-22.28,23.78-22.28h20.52c4.48,0,8.2,3.27,8.89,7.56l23.69-20.19c.43-.37,10.9-9.33,14.53-12.38,3.63-3.05,5.68-7,5.77-11.12.09-3.84-1.49-7.45-4.44-10.16-3.63-3.34-3.89-8.97-.6-12.64,1.78-1.98,4.23-2.99,6.7-2.99,2.11,0,4.22.73,5.93,2.23,15.4,13.49,24.3,32.87,24.49,53.27.02.21.02.43.02.65,0,39.52-32.16,71.68-71.68,71.68h-59.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M232.04,57.44c13.12,11.49,21.42,28.36,21.42,47.14h.02c0,34.56-28.12,62.68-62.68,62.68h-59.56s7.34-22.23,9.97-30.14c2.66-7.96,5.06-17.76,15.78-17.76h20.52v17.96l38.41-32.74s10.84-9.28,14.48-12.34c11.83-9.95,11.56-25.67,1.64-34.8M232.05,39.43c-4.94,0-9.85,2.02-13.4,5.97-6.58,7.33-6.05,18.6,1.2,25.27,1.03.95,1.56,2.1,1.53,3.34-.03,1.52-.92,3.05-2.57,4.44-3.66,3.07-14.15,12.06-14.6,12.44l-16.22,13.82c-2.95-2.12-6.57-3.37-10.49-3.37h-20.52c-10.15,0-19.01,4.46-24.94,12.55-3.95,5.39-5.86,11.24-7.39,15.94-.17.53-.34,1.05-.52,1.57-2.64,7.95-9.99,30.2-9.99,30.2-1.81,5.49-.88,11.51,2.5,16.19,3.38,4.68,8.81,7.45,14.59,7.45h59.56c44.49,0,80.68-36.19,80.68-80.68,0-.33,0-.65-.03-.97-.28-22.87-10.28-44.58-27.56-59.71-3.41-2.99-7.64-4.46-11.85-4.46h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M215.94,113.58c-2.08,0-4.16-.72-5.84-2.15l-23.69-20.19c-.69,4.29-4.4,7.56-8.89,7.56h-50.26c-2.89,0-5.6-1.38-7.29-3.72-1.69-2.34-2.16-5.35-1.26-8.09l15.74-47.89c1.21-3.69,4.66-6.19,8.55-6.19h47.81c17.01,0,33.48,6.07,46.42,17.1.08.07.35.3.37.32,0,0,.5.45.56.5,6.7,6.17,10.44,14.84,10.24,23.8-.21,9.37-4.53,18.07-12.18,24.51-.13.11-.26.21-.39.31-3.89,3.28-13.94,11.88-14.04,11.97-1.68,1.44-3.77,2.16-5.85,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.82,41.91c15.54,0,29.78,5.68,40.74,15.09.02,0,.02.02.04.03.16.14.31.28.47.42,9.92,9.13,10.18,24.85-1.64,34.8h0c-3.64,3.05-14.48,12.33-14.48,12.33l-38.41-32.74v17.96h-50.26l15.74-47.89h47.81M190.82,23.91h-47.81c-7.78,0-14.67,4.99-17.1,12.38l-15.74,47.89c-1.8,5.48-.87,11.5,2.52,16.18,3.39,4.68,8.81,7.44,14.58,7.44h50.26c3.91,0,7.53-1.25,10.49-3.37l16.25,13.85c3.36,2.87,7.52,4.3,11.68,4.3s8.34-1.44,11.71-4.33c.1-.09,9.86-8.44,13.82-11.79.19-.14.37-.29.55-.45,9.65-8.12,15.11-19.2,15.38-31.19.26-11.54-4.53-22.7-13.14-30.62-.1-.09-.2-.18-.3-.27l-.06-.05c-.13-.12-.26-.24-.4-.36-.16-.15-.33-.29-.5-.43-14.55-12.38-33.07-19.19-52.18-19.19h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M68.35,213.89c-2.89,0-5.6-1.39-7.3-3.73-1.69-2.34-2.16-5.35-1.25-8.1l20.58-62.17c5.75-17.38,21.77-29.52,38.95-29.52h36.92c.24,0,.49-.01.73-.01,2.39,0,4.69.95,6.37,2.65,2.57,2.58,3.34,6.45,1.94,9.81-1.4,3.36-4.67,5.55-8.31,5.55h-.42c-2.41.13-3.55,1.53-6.27,9.87-.19.58-.38,1.15-.56,1.72-2.63,7.89-9.96,30.12-9.96,30.12l-12.45,37.64c-1.22,3.68-4.66,6.17-8.54,6.17h-50.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157,119.36h.01s-.6,0-.6,0c.19,0,.39,0,.59,0M156.41,119.36c-10.23.35-12.59,9.94-15.19,17.75-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.07M157,101.36c-.28,0-.56,0-.84,0h-36.82c-21.02,0-40.55,14.68-47.5,35.7l-20.58,62.16c-1.82,5.49-.89,11.51,2.5,16.2,3.38,4.68,8.81,7.46,14.59,7.46h50.45c7.76,0,14.65-4.98,17.09-12.35l12.45-37.63c.08-.23,7.37-22.32,9.96-30.11.19-.58.39-1.18.58-1.78.38-1.18.88-2.71,1.35-3.95,5.95-1.08,11.05-5.12,13.42-10.84,2.78-6.74,1.22-14.49-3.95-19.63-3.37-3.35-7.95-5.25-12.7-5.25h0Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.55,89.8h-38.2l12.67-38.56c1.83-5.57,7.03-9.34,12.9-9.34h28.37l-15.74,47.89h0Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M120.91,119.35c-10.73,0-13.13,9.8-15.78,17.76-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M244.87,51.38l48.98-7.73,7.58,84.84,16.94-64.66c3.13-11.95,13.93-20.28,26.28-20.28h6.15c7.47,0,12.92,7.06,11.03,14.29l-38.35,146.42-49.4.85-17.26-89-23.09,88.16h-36.74l47.89-152.87v-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "324.07 205.1 273.75 205.1 319.62 43.53 342.61 43.69 358.84 43.69 367.74 43.69 324.07 205.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.24,43.69c-10.7,0-13.09,9.78-15.74,17.71-2.63,7.88-9.94,30.06-9.94,30.06l-30.42,113.63h-45.17l38.53-138.11c4.05-12.25,15.88-23.29,30.34-23.29h32.41-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.48,104.58c0,34.56-28.12,62.68-62.68,62.68h-59.56s7.34-22.23,9.97-30.14c2.66-7.96,5.06-17.76,15.78-17.76h20.52v17.96l38.41-32.74s10.84-9.28,14.48-12.34c11.83-9.95,11.56-25.67,1.64-34.8,13.12,11.49,21.42,28.36,21.42,47.14h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M230.42,92.23c-3.64,3.06-14.48,12.34-14.48,12.34l-38.41-32.74v17.96h-50.26l15.74-47.89h47.81c15.54,0,29.78,5.68,40.74,15.09.02,0,.02.02.04.03.16.14.31.28.47.42,9.92,9.13,10.18,24.85-1.64,34.8h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M157,119.35c-10.73,0-13.13,9.8-15.78,17.76-2.63,7.9-9.97,30.14-9.97,30.14l-12.45,37.63h-50.45l20.58-62.17c4.06-12.28,15.92-23.35,30.41-23.35h37.67-.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpn);
export default __webpack_public_path__ + "static/media/IPN.8c30c1f86c23dc08151280b033336831.svg";
export { ForwardRef as ReactComponent };